module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/lyft.413d9804926c8941f26a58c6358399ce.png";